// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Types
import { HeaderLayoutHookUtilsType } from './types/header-layout.hook.utils.type';
// Utilities
import { allNeedDataIsLoaded } from 'providers/app-information/utils/app-information.utils';

const backButtonMustBeDisabled = ({
  currentState,
  informationFlags,
}: HeaderLayoutHookUtilsType): boolean =>
  !allNeedDataIsLoaded(informationFlags) ||
  [
    AppStatesEnumeration.DECLINED,
    AppStatesEnumeration.CHECKOUT_COMPLETED,
    AppStatesEnumeration.CANCELLED,
    AppStatesEnumeration.LOADING,
    AppStatesEnumeration.SUCCESS,
    AppStatesEnumeration.CHECKOUT_SIGNED,
    AppStatesEnumeration.CHECKOUT_SIGNED_PENDING,
    AppStatesEnumeration.ERROR,
    AppStatesEnumeration.PROCESS_ENDED,
  ].includes(currentState);

export { backButtonMustBeDisabled };
